<template>
  <v-row v-observe-visibility="visibilityChanged"
         class="pa-3 mt-2"
  >
    <alert-error :is-alert-visible.sync="isAlertVisible"
                 :error="errors.token"
    ></alert-error>
    <v-col cols="12"
           md="10"
    >
      <v-card>
        <v-card-title>
          <div>
            <h5 class="font-weight-bold text-uppercase">
              {{ $t('Logs') }}
            </h5>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon
                 color="primary"
                 class="me-3"
                 :loading="loading"
                 :disabled="loading"
                 @click="fetchDatas()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-5"></v-divider>
        <v-card-text class="d-flex align-center flex-wrap pb-0">
          <div class="d-flex flex-grow-1 align-center pb-3">
          </div>
        </v-card-text>

        <v-data-table
          v-model="selectedTableData"
          :headers="tableColumns"
          :items="listTable"
          :options.sync="options"
          :server-items-length="totalListTable"
          :loading="loading"
          :single-select="true"
          class="text-no-wrap"
        >
          <template #[`item.status`]="{ item }">
            <table-cell-item
              :filter="false"
              :source="{
                type: 'chip-type',
                value: item.status,
                text: item.status,
              }"
            >
            </table-cell-item>
          </template>
          <template #[`item.payload`]="{ item }">
            <table-cell-item
              :filter="false"
              :source="{
                type: 'json',
                value: item.payload,
                text: item.payload,
              }"
            >
            </table-cell-item>
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ $moment(item.created_at).format('lll') }}
          </template>
          <template #[`item.updated_at`]="{ item }">
            {{ $moment(item.updated_at).format('lll') }}
          </template>

          <template #[`item.actions`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-btn x-small
                     outlined
                     class="me-3"
                     color="primary"
                     @click="editDialog(item)"
              >
                <v-icon> mdi-magnify </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-dialog v-model="isAddDialogVisible"
              max-width="450"
    >
      <v-card v-if="log"
              class="pa-sm-6 pa-3"
      >
        <v-card-title class="justify-center text-h5 text-uppercase">
          {{ log.name }}
        </v-card-title>

        <v-card-text class="pt-5">
          <v-form ref="form">
            <vue-json-pretty v-if="log.message"
                             :data="log.message"
            />
            <div class="mt-6 d-flex justify-center">
              <v-btn v-if="false"
                     :loading="loadingAction"
                     :disabled="loadingAction"
                     color="primary"
                     class="me-3"
                     type="submit"
              >
                {{ $t('Submit') }}
              </v-btn>
              <v-btn outlined
                     color="secondary"
                     @click="isAddDialogVisible = false"
              >
                {{ $t('Cancel') }}
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  ref, getCurrentInstance, onBeforeMount,
} from 'vue'
import { required, emailValidator, sanatize } from '@core/utils/validation'
import { avatarText } from '@core/utils/filter'
import AlertError from '@/components/AlertError.vue'
import useLogList from '@/views/workspaces/settings/useLogList'
import VueJsonPretty from 'vue-json-pretty'
import TableCellItem from '@/views/table/TableCellItem.vue'
import { useUserStore } from '@/stores/user.store'
import { useWorkspacesLogsStore } from '@/stores/workspaces_logs.store'

export default {
  components: {
    AlertError,
    VueJsonPretty,
    TableCellItem,
  },
  props: {},

  setup() {
    const errors = ref({})
    const loadingAction = ref(false)
    const form = ref(null)
    const log = ref(null)
    const isAlertVisible = ref(false)
    const subscription = ref(null)
    const vm = getCurrentInstance().proxy
    const userStore = useUserStore()
    const logsStore = useWorkspacesLogsStore()

    const {
      listTable,
      searchQuery,
      tableColumns,
      options,
      totalListTable,
      loading,
      selectedTableData,
      isAddDialogVisible,
      fetchDatas,
    } = useLogList(vm.$router.currentRoute.params.id)

    const visibilityChanged = async isVisible => {
      if (isVisible) {
        fetchDatas()
        subscription.value = await logsStore.listenLogs(vm.$router.currentRoute.params.id)
      } else {
        userStore.removeChannel(subscription.value)
      }
    }

    onBeforeMount(() => {
      tableColumns.forEach(element => {
        if (element.text) {
          // eslint-disable-next-line no-param-reassign
          element.text = vm.$t(element.text).toUpperCase()
        }
      })
    })

    const editDialog = async _item => {
      isAddDialogVisible.value = true
      log.value = _item
    }

    const parseBoolean = val => sanatize('boolean', val)

    return {
      tableColumns,
      searchQuery,
      options,
      totalListTable,
      listTable,
      loading,
      loadingAction,
      selectedTableData,
      validators: {
        required,
        emailValidator,
      },
      isAddDialogVisible,
      errors,
      isAlertVisible,
      form,
      avatarText,
      log,
      editDialog,
      visibilityChanged,
      parseBoolean,
      fetchDatas,
    }
  },
}
</script>
